// MyGoogleMaps.js
import React, { useState, useEffect, useCallback } from 'react';
import GoogleMapReact from 'google-map-react';
import Button from './HexButton/button';
import styled from 'styled-components';
import AutoComplete from './Autocomplete';
import Markerimg from './images/marker.jpg';
import './auto.css';

const Wrapper = styled.main`
    width: 100%;
    height: 90vh;
    position: relative;
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: -75px;
`;

const MyGoogleMap = ({ latlag }) => {
    const [mapApiLoaded, setMapApiLoaded] = useState(false);
    const [mapInstance, setMapInstance] = useState(null);
    const [mapApi, setMapApi] = useState(null);
    const [places, setPlaces] = useState([]);
    const [center, setCenter] = useState([]);
    const [zoom, setZoom] = useState(9);
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);

    // Set current location on mount (replaces componentDidMount)
    useEffect(() => {
        setCurrentLocation();
    }, []);

    const setCurrentLocation = () => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                setCenter([position.coords.latitude, position.coords.longitude]);
                setLat(position.coords.latitude);
                setLng(position.coords.longitude);
            });
        }
    };

    const apiHasLoaded = useCallback((map, maps) => {
        setMapApiLoaded(true);
        setMapInstance(map);
        setMapApi(maps);
    }, []);

    const onChange = useCallback(({ center, zoom }) => {
        setCenter(center);
        setZoom(zoom);
        setLat(center.lat);
        setLng(center.lng);
    }, []);

    const addPlace = useCallback((place) => {
        setPlaces([place]);
        setLat(place.geometry.location.lat());
        setLng(place.geometry.location.lng());
    }, []);

    const handleChange = useCallback(() => {
        if (latlag) {
            latlag(lat, lng);
        }
    }, [lat, lng, latlag]);

    return (
        <>
            {mapApiLoaded && (
                <div>
                    <AutoComplete
                        map={mapInstance}
                        mapApi={mapApi}
                        addplace={addPlace}
                    />
                    <Button
                        buttonTitle="Select"
                        id="mapbutton"
                        onClick={handleChange}
                    />
                </div>
            )}

            <Wrapper>
                <GoogleMapReact
                    center={{ lat: 28.404599599999997, lng: 77.30487599999998 }}
                    zoom={zoom}
                    onChange={onChange}
                    bootstrapURLKeys={{
                        key: "AIzaSyCKFAHPrHa_vAZJf-fIeJcHH6Coit9GD-E",
                        libraries: ['places', 'geometry'],
                    }}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => apiHasLoaded(map, maps)}
                >
                </GoogleMapReact>

                <div style={{ position: 'absolute' }}>
                    <img style={{ width: '55px' }} src={Markerimg} alt="map marker" />
                </div>
            </Wrapper>
        </>
    );
};

export default MyGoogleMap;